import bootstrapIcon from "images/icon-pack/svg/with-background/bootstrap-icon.svg";
import BraveIcon from "images/icon-pack/svg/with-background/brave.svg";
import ChromeIcon from "images/icon-pack/svg/with-background/chrome.svg";
import EdgeIcon from "images/icon-pack/svg/with-background/edge.svg";
import figmaIcon from "images/icon-pack/svg/with-background/figma-icon.svg";
import gatsbyIcon from "images/icon-pack/svg/with-background/gatsby-icon.svg";
import MozillaIcon from "images/icon-pack/svg/with-background/mozilla.svg";
import nextIcon from "images/icon-pack/svg/with-background/next-icon.svg";
import OperaIcon from "images/icon-pack/svg/with-background/opera.svg";
import reactIcon from "images/icon-pack/svg/with-background/react-icon.svg";
import SafariIcon from "images/icon-pack/svg/with-background/safari.svg";
import sassIcon from "images/icon-pack/svg/with-background/sass-icon.svg";
import shopifyIcon from "images/icon-pack/svg/with-background/shopify-icon.svg";
import spreeIcon from "images/icon-pack/svg/with-background/spree-icon.svg";
import tailwindIcon from "images/icon-pack/svg/with-background/tailwind-icon.svg";
import typescriptIcon from "images/icon-pack/svg/with-background/typescript-icon.svg";
import vueIcon from "images/icon-pack/svg/with-background/vue-icon.svg";
import bootstrapIconWithoutBackgroud from "images/icon-pack/svg/without-background/bootstrap-icon.svg";
import figmaIconWithoutBackgroud from "images/icon-pack/svg/without-background/figma-icon.svg";
import gatsbyIconWithoutBackgroud from "images/icon-pack/svg/without-background/gatsby-icon.svg";
import nextIconWithoutBackgroud from "images/icon-pack/svg/without-background/next-icon.svg";
import reactIconWithoutBackgroud from "images/icon-pack/svg/without-background/react-icon.svg";
import sassIconWithoutBackgroud from "images/icon-pack/svg/without-background/sass-icon.svg";
import shopifyIconWithoutBackgroud from "images/icon-pack/svg/without-background/shopify-icon.svg";
import spreeIconWithoutBackgroud from "images/icon-pack/svg/without-background/spree-icon.svg";
import tailwindIconWithoutBackgroud from "images/icon-pack/svg/without-background/tailwind-icon.svg";
import typescriptIconWithoutBackgroud from "images/icon-pack/svg/without-background/typescript-icon.svg";
import vueIconWithoutBackgroud from "images/icon-pack/svg/without-background/vue-icon.svg";




export const getIconData = (iconName: string) => {
  switch (iconName) {
    case "Tailwind":
      return { icon: tailwindIcon, alt: "Icon for Tailwind" };

    case "Figma":
      return { icon: figmaIcon, alt: "Icon for Figma" };

    case "Bootstrap":
      return { icon: bootstrapIcon, alt: "Icon for Bootstrap" };

    case "Spree":
      return { icon: spreeIcon, alt: "Icon for Spree" };

    case "React":
      return { icon: reactIcon, alt: "Icon for React" };

    case "Vue":
      return { icon: vueIcon, alt: "Icon for Vue" };

    case "Shopify":
      return { icon: shopifyIcon, alt: "Icon for Shopify" };

    case "Next":
      return { icon: nextIcon, alt: "Icon for Next" };

    case "Gatsby":
      return { icon: gatsbyIcon, alt: "Icon for Gatsby" };

    case "Typescript":
      return { icon: typescriptIcon, alt: "Icon for Typescript" };

    case "Sass":
      return { icon: sassIcon, alt: "Icon for Sass" };

    case "Brave":
      return { icon: BraveIcon, alt: "Icon for Brave browser" };
    
    case "Chrome":
          return { icon: ChromeIcon, alt: "Icon for Chrome browser" };

    case "Edge":
            return { icon: EdgeIcon, alt: "Icon for Edge browser" };

    case "Mozilla":
      return { icon: MozillaIcon, alt: "Icon for Mozilla browser" };
    
    case "Opera":
        return { icon: OperaIcon, alt: "Icon for Opera browser" };

    case "Safari":
        return { icon: SafariIcon, alt: "Icon for Safari browser" };

    default:
      return {
        icon: sassIconWithoutBackgroud,
        alt: "Placeholder Image for default case",
      };
  }
};

export const getIconWithoutBackgroudData = (iconName: string) => {
  switch (iconName) {
    case "Tailwind":
      return { icon: tailwindIconWithoutBackgroud, alt: "Icon for Tailwind" };

    case "Figma":
      return { icon: figmaIconWithoutBackgroud, alt: "Icon for Figma" };

    case "Bootstrap":
      return { icon: bootstrapIconWithoutBackgroud, alt: "Icon for Bootstrap" };

    case "Spree":
      return { icon: spreeIconWithoutBackgroud, alt: "Icon for Spree" };

    case "React":
      return { icon: reactIconWithoutBackgroud, alt: "Icon for React" };

    case "Vue":
      return { icon: vueIconWithoutBackgroud, alt: "Icon for Vue" };

    case "Shopify":
      return { icon: shopifyIconWithoutBackgroud, alt: "Icon for Shopify" };

    case "Next":
      return { icon: nextIconWithoutBackgroud, alt: "Icon for Next" };

    case "Gatsby":
      return { icon: gatsbyIconWithoutBackgroud, alt: "Icon for Gatsby" };

    case "Typescript":
      return {
        icon: typescriptIconWithoutBackgroud,
        alt: "Icon for Typescript",
      };

    case "Sass":
      return { icon: sassIconWithoutBackgroud, alt: "Icon for Sass" };

    default:
      return {
        icon: sassIconWithoutBackgroud,
        alt: "Placeholder Image for default case",
      };
  }
};
